<template>
	<div class="training-agreement">
		<div class="training-agreement__container container">
			<div
				class="agreement-head training-main-name main-title"
				v-html="agreement.title"
			></div>

			<CreatedBy
				:createdBy="agreement.createdBy"
				:createdAt="agreement.updatedAt"
				:reason="agreement.reason"
			/>

			<ActionNavigationBar
				:countOfBlocks="marksCount"
        :isOSHA="isOSHA"
				:done="trainingAction.done"
			/>
		</div>

		<div class="swiper-self-wrapper">
			<swiper
				class="swiper"
				v-bind="swiperParameters"
				@slideChange="$emit('slideChanged')"
			>
				<swiper-slide
					v-for="(content, idx) in agreementContentSwiper"
					:key="idx"
					class=""
				>
					<div class="swiper-slide-wrapper">
						<div class="slider-body card-shadow1">
							<div class="procedure-title">
								<span v-if="content.children && !content.paragraph"> {{ content.position }}. </span>
								<span v-html="content.content"></span>
							</div>
							<ol class="description" v-if="!content.paragraph">
								<li
									class="unordered-list-of-paragraphs"
									v-for="(content, idx) in content.children"
									:key="idx"
								>
									<span v-html="content.content"></span>
                  <ol class="sub-description" style="list-style: lower-roman;">
                    <li
                        v-for="(content, idx) in content.children"
                        :key="idx"
                    >
                      <span v-html="content.content"></span>
                    </li>
                  </ol>
								</li>
							</ol>
						</div>
					</div>
				</swiper-slide>
				<swiper-slide>
					<div class="swiper-slide-wrapper">
						<div class="slider-body card-shadow1">
							<div class="procedure-title">
								Acknowledgement:
							</div>
							<div
								class="description"
								style="margin-bottom: 20px"
							>
								<div
									v-for="(content, idx) of agreementContentConfirm"
									:key="idx"
								>
                  <p v-html="content.content"></p>

                  <ol class="description" style="list-style: decimal">
                    <li
                        v-for="(content, idx) in content.children"
                        :key="idx"
                    >
                      <span v-html="content.content"></span>
                    </li>
                  </ol>
                </div>

								<div class="confirm-block trainings-action-page">
									<label
										class="checkbox"
										@change="$emit('agreeWithProcedure')"
									>
										<input type="checkbox" />
										<i class="icon-checkbox"> </i>
										<div class="text">
											I have reviewed our practice's
											{{ agreement.title }}
											and agree to comply with these expectations.
											<div
												v-if="trainingAction.done"
												class="accepted"
											>
												{{
													`You accepted on ${transformDate(trainingAction.doneStaffMap[0]?.created)}`
												}}
											</div>
										</div>
									</label>
									<div
										class="submit-button trainings-action-page"
										v-if="!trainingAction.done"
									>
										<f7-button @click="$emit('submit')"> Submit </f7-button>
									</div>
								</div>
							</div>
						</div>
					</div>
				</swiper-slide>
			</swiper>
		</div>
	</div>
</template>
<script>
	import { Swiper, SwiperSlide } from "swiper/vue";
	import { Navigation, Pagination } from "swiper";
	import "swiper/css";

	import CreatedBy from "@/components/CreatedBy.vue";
	import ActionNavigationBar from "@/components/ActionNavigationBar.vue";

	export default {
		beforeMount() {
			this.marksCount = this.agreementContentSwiper?.length || 0;
		},

		mounted() {
			if (this.trainingAction.done) {
				const checkbox = document.querySelector('input[type="checkbox"]');
				checkbox.checked = true;
				checkbox.disabled = true;
			}
		},

		data() {
			return {
				marksCount: 0,
				agreedWithAction: false,
				swiperParameters: {
					slidesPerView: 1,
					autoHeight: true,
					modules: [Navigation, Pagination],
				},
			};
		},

		props: {
			showDescription: Boolean,
			agreement: Object,
			trainingAction: Object,
			transformDate: Function,
      isOSHA: {
        type: Boolean,
        default: false,
      },
		},

		components: {
			SwiperSlide,
			Swiper,
			CreatedBy,
			ActionNavigationBar,
		},

		methods: {
			changeSlideFromMarkProc(x) {
				this.$emit("changeSlideFromMark", x);
			},
		},

		computed: {
			agreementContentConfirm() {
				return this.$store.getters["trainings/agreementContentConfirm"];
			},

			agreementContentSwiper() {
				return this.$store.getters["trainings/agreementContentSwiper"];
			},
		},
	};
</script>
<style lang="scss"></style>
